export default {"src":"/_next/static/media/QCOM.c8bb7e09.svg","height":18,"width":18};